export function syncNavigationWithUserRole() {
  const userRole = localStorage.getItem("userRole");

  if (userRole === "Hr") {
    localStorage.setItem("navigation", "skills");
  } else if (userRole === "Enterprise") {
    localStorage.setItem("navigation", "enterprise");
  } else if (userRole === "User") {
    localStorage.setItem("navigation", "individual");
  }
}